import React, { useEffect, useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { PieChart, CallMade } from "@mui/icons-material";
import { Phone } from "lucide-react";
import Timmer from "./Timmer";
import apiEndPointsConfig from "../../../services/apiEndPoints";

export default function WelcomeSection({
  userDetails,
  data,
  stats,
  tickets,
  calls,
}) {
  console.log(calls, "calls");

  return (
    <Box
      sx={{
        mt: 3,
      }}
    >
      <Grid container spacing={2}>
        {/* Welcome Text */}
        <Grid item xs={12} md={4}>
          <Box
            sx={{
              borderRadius: 6,
              border: "1px solid #EEEEEE",
              overflow: "hidden",
            }}
          >
            <Typography variant="body1" sx={{ p: 1.7 }}>
              <Box
                component="span"
                sx={{ color: "text.secondary", fontWeight: 900 }}
              >
                Welcome{" "}
              </Box>
              <Box component="span" sx={{ color: "orange", fontWeight: 900 }}>
                {userDetails?.companyName}!
              </Box>
            </Typography>
            <Box
              sx={{
                border: "1px solid #EEEEEE",
                // p: "2.55px 0 0px 0",
              }}
            ></Box>
            <Typography
              sx={{ p: 1.7, color: "text.secondary", fontSize: "small" }}
            >
              Here's Your Customer Care Number :{" "}
              <Box component="span" sx={{ color: "#1a237e" }}>
                {userDetails?.customerCareNo == null
                  ? "N/A"
                  : userDetails?.customerCareNo}
              </Box>
            </Typography>
            <Box
              sx={{
                border: "1px solid #EEEEEE",
                // p: "5px 0 0px 0",
              }}
            ></Box>
            <Typography
              sx={{
                color: "text.secondary",
                fontSize: "small",
              }}
            >
              <Timmer data={userDetails} />
            </Typography>
          </Box>
        </Grid>

        {/* Assignee Section */}
        <Grid item xs={12} md={4}>
          <Box
            sx={{
              borderRadius: 6,
              border: "1px solid #EEEEEE",
              p: 3,
              "&:hover": {
                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              },
            }}
          >
            {/* Header */}
            <Box sx={{ display: "flex", alignItems: "center", mb: 4 }}>
              <Box
                sx={{
                  width: 30,
                  height: 30,
                  borderRadius: 2,
                  // bgcolor: "#f0f0ff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mr: 2,
                }}
              >
                <PieChart sx={{ color: "#6366f1" }} />
              </Box>
              <Typography variant="body1" sx={{ fontWeight: 550, flexGrow: 1 }}>
                Assignee
              </Typography>
            </Box>

            {/* Metrics */}
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "repeat(3, 1fr)",
                gap: 3,
              }}
            >
              <Box>
                <Typography
                  color="text.secondary"
                  sx={{ mb: 1, fontSize: "small" }}
                >
                  All Tickets
                </Typography>
                <Typography sx={{ fontWeight: "small" }}>
                  {tickets.length || 0}
                </Typography>
              </Box>
              <Box>
                <Typography
                  color="text.secondary"
                  sx={{ mb: 1, fontSize: "small" }}
                >
                  Agent
                </Typography>
                <Typography sx={{ fontWeight: "small" }}>
                  {stats?.agents || 0}
                </Typography>
              </Box>
              <Box>
                <Typography
                  color="text.secondary"
                  sx={{ mb: 1, fontSize: "small" }}
                >
                  Clients
                </Typography>
                <Typography sx={{ fontWeight: "small" }}>
                  {" "}
                  {stats?.clients || 0}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Grid>

        {/* Call Details Section */}
        <Grid item xs={12} md={4}>
          <Box
            sx={{
              borderRadius: 6,
              border: "1px solid #EEEEEE",
              p: 3,
              "&:hover": {
                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              },
            }}
          >
            {/* Header */}
            <Box sx={{ display: "flex", alignItems: "center", mb: 4 }}>
              <Box
                sx={{
                  width: 30,
                  height: 30,
                  borderRadius: 2,
                  // bgcolor: "#f0f0ff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mr: 2,
                }}
              >
                <Phone size={20} style={{ color: "#6366f1" }} />
              </Box>
              <Typography variant="body1" sx={{ fontWeight: 550, flexGrow: 1 }}>
                Call Details
              </Typography>
            </Box>

            {/* Metrics */}
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "repeat(3, 1fr)",
                gap: 3,
              }}
            >
              <Box>
                <Typography
                  color="text.secondary"
                  sx={{ mb: 1, fontSize: "small" }}
                >
                  All Calls
                </Typography>
                <Typography sx={{ fontWeight: "small" }}>
                  {" "}
                  {calls?.totalCalls || 0}
                </Typography>
              </Box>
              <Box>
                <Typography
                  color="text.secondary"
                  sx={{ mb: 1, fontSize: "small", whiteSpace: "nowrap" }}
                >
                  Avg Duration
                </Typography>
                <Typography sx={{ fontWeight: "small", color: "#6366f1" }}>
                  {" "}
                  {calls?.avgDuration || "0:00"}
                </Typography>
              </Box>
              <Box>
                <Typography
                  color="text.secondary"
                  sx={{ mb: 1, fontSize: "small", whiteSpace: "nowrap" }}
                >
                  Total Duration
                </Typography>
                <Typography sx={{ fontWeight: "small", color: "#6366f1" }}>
                  {calls?.totalDuration || "0:00"}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
